import React from "react";
import companyLogo from "../../assets/images/logo.png";
import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ThankYou = () => {
  const location1 = useLocation();
  console.log("location1---->", location1);

  const { t, i18n } = useTranslation();
  i18n.changeLanguage(location1 && location1.state && location1.state.language);
  return (
    <div className="container-scroller mainpannel">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-10 mx-auto">
              <div className="brand-logo ">
                <Link to="/dashboard">
                  <img src={companyLogo} alt="logo" className="logo center" />
                </Link>
              </div>

              <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                {/* ✅ Priest Registration (NEW ADDED CONDITION) */}
                {location1 &&
                location1.state &&
                location1.state.condition === "priestRegister" ? (
                  <div className="text-center">
                    <h3>{t("thank_you_for_prtiest")}</h3>
                  </div>
                ) : location1 &&
                  location1.state &&
                  location1.state.condition === "New Register Retreat" ? (
                  <div className="text-center">
                    <h3>{t("thank_you_retreat_registration")}</h3>
                    <p>{t("We_will_review_and_confirm")}</p>
                  </div>
                ) : (
                  <div>
                    {/* ✅ Profile Update */}
                    {location1 && location1.state === "Profile" ? (
                      <div className="text-center">
                        <h3>Thank You!</h3>
                        <p>Thank you for updating the profile information.</p>
                      </div>
                    ) : location1?.state?.value === "New Register Couple" ? (
                      <>
                        {location1.state.data?.mail_msg ? (
                          <>
                            <div
                              className="mb-4"
                              dangerouslySetInnerHTML={{
                                __html: location1.state.data.mail_msg,
                              }}
                            />
                            {location1?.state?.data?.paymentLink ? (
                              <h5 className="text-center">
                                <strong>{t("retreat_payment_link")} - </strong>{" "}
                                <a
                                  href={location1?.state?.data?.paymentLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#007bff",
                                    textDecoration: "underline",
                                  }}
                                >
                                  {location1?.state?.data?.paymentLink}
                                </a>
                              </h5>
                            ) : null}
                          </>
                        ) : (
                          <div className="text-center">
                            <h3>{t("couple_register_retreat_msg")}</h3>
                            <p>{t("check_email_and_verify")}</p>
                          </div>
                        )}
                      </>
                    ) : location1?.state?.value ===
                      "Register WaitList Couple" ? (
                      /* ✅ WaitList */
                      <div className="text-center">
                        <h3 className="waitListThanks">
                          Thank you for joining the waitlist for the “
                          <strong>
                            {`${location1?.state?.data?.myparish?.parish}`}{" "}
                            LOVESTRONG Marriage”
                          </strong>
                          retreat.
                        </h3>

                        <h5 className="mt-4">
                          We’re delighted about your interest and look forward
                          to welcoming you to a future retreat!
                        </h5>
                      </div>
                    ) : (
                      <>
                        {location1.state?.data?.mail_msg ? (
                          <>
                            <div
                              className="mb-4"
                              dangerouslySetInnerHTML={{
                                __html: location1.state.data.mail_msg,
                              }}
                            />
                            {location1?.state?.data?.paymentLink ? (
                              <h5 className="text-center">
                                <strong>{t("retreat_payment_link")} - </strong>{" "}
                                <a
                                  href={location1?.state?.data?.paymentLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#007bff",
                                    textDecoration: "underline",
                                  }}
                                >
                                  {location1?.state?.data?.paymentLink}
                                </a>
                              </h5>
                            ) : null}
                          </>
                        ) : (
                          <div className="text-center">
                            <h3>{t("couple_register_retreat_msg")}</h3>
                            <h5 className="mt-2">
                              {t("wait_confirmation_aAdmin")}
                            </h5>
                            <br />
                            <h4>{t("can_login_your_account")}</h4>
                            <h5 className="mt-3">
                              {location1.state?.hisEmail || ""}
                              {location1.state?.hisEmail &&
                              location1.state?.herEmail
                                ? " Or "
                                : ""}
                              {location1.state?.herEmail || ""}
                            </h5>
                            <h4 className="d-flex justify-content-center mt-3">
                              <Link className="loginLinkInThanku" to="/login">
                                {t("login")}
                              </Link>
                              <Link to="/forgetPassword">
                                {" "}
                                {t("forget_password")}
                              </Link>
                            </h4>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
